import { render, staticRenderFns } from "./OverlayPalette.vue?vue&type=template&id=3af043b0&scoped=true&"
import script from "./OverlayPalette.vue?vue&type=script&lang=js&"
export * from "./OverlayPalette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af043b0",
  null
  
)

export default component.exports